import { render } from "./PushuserDashboard.vue?vue&type=template&id=2fc8567c"
import script from "./PushuserDashboard.vue?vue&type=script&lang=js"
export * from "./PushuserDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__